import React, { useRef } from 'react'
import { useState } from 'react';
import { ROW_SELECTION_OPTIONS } from '../../../components/richgrid/constants';
import Label from '../../../components/label/Label';
import TextInput from '../../../components/input/textinput/TextInput';
import RichGrid from '../../../components/richgrid/RichGrid';
import { LABEL_WEIGHT } from '../../../components/label/constants';
import styles from './DeveloperHub.styles'
import Button from '../../../components/button/Button';
import Heading from '../../../components/heading/Heading';
import { HEADING } from '../../../components/heading/constants/constants';
import { useEffect } from 'react';
import { componentKey, setRowsPerPage, setShowInvitePopup, setSkip } from '../ApiSlice';
import { useDispatch, useSelector } from 'react-redux';
import { deleteDeveloper, getDeveloperList, inviteDeveloper, managerShowProdAppKey } from '../ApiSaga';
import Icons from '../../../components/icons/Icons';
import { VEC_ICON_NAME } from '../../../components/icons/constants';
import { BUTTON_TYPE } from '../../../components/button/constants';
import CommaSeparatedInput from '../../../components/input/commaseparatedtextinput/CommaSeparatedTextInput';
import Popup from '../../../components/popup/Popup';
import Loadable from '../../../components/loadable/Loadable';
import { API_HUB_LOADING_STATES, COMMON_LOADING_STATES, COMMON_LOADING_STATES_MESSAGE_MAP } from '../../constants/constants';
import { addNotifications } from '../../toaster/ToasterPortalSlice';
import useTxNavigate from '../../../../libs/txnavigate/TxNavigateHook';
import { PAGE_PATH } from '../../dashboard/constants/constant';
import Breadcrumbs from '../../../components/breadcrumbs/Breadcrumbs';

export default function DeveloperHub() {

	const { loadingState, skip, rowsPerPage, developerData, totalDeveloper, showInvitePopup, isMndaSigned } = useSelector((state) => state[componentKey])

	const navigate = useTxNavigate();
	const dispatch = useDispatch();
	const [filterText, setFilterText] = useState('');
	const [emailList, setEmailList] = useState([]);
	const commaSeperatedInputRef = useRef();

	useEffect(() => {
		if(!showInvitePopup) {
			dispatch(getDeveloperList({ 
				memberName: filterText, 
				page: (skip / rowsPerPage) + 1,
				pageSize: rowsPerPage,  
			}))
		}
	}, [filterText, skip, rowsPerPage, showInvitePopup])

	const handleChangeUserAccess = (row) => {
		dispatch(managerShowProdAppKey({ userId: row.UserId, action: row.ShowProdAppKey ? 'revoke' : 'grant' }))
	}

	const handleUserDelete = (row) => {
		dispatch(deleteDeveloper(row.UserId))
	}

	useEffect(() => {
		if(isMndaSigned === false) {
			navigate(PAGE_PATH.DASHBOARD)
		}
	}, [isMndaSigned])

	const gridHeader = [
		{
			field: "firstName",
			header: <Label weight={LABEL_WEIGHT[700]} customStyles={styles.text}>First Name</Label>,
			renderLogic: (row, idx) => <span style={styles.text}>{row.FirstName}</span>
		},
		{
			field: "email",
			header: <Label weight={LABEL_WEIGHT[700]}>Email</Label>,
			renderLogic: (row, idx) => <span style={styles.text}>{row.Email}</span>
		},
		{
			field: "action",
			header: <Label weight={LABEL_WEIGHT[700]}>Action</Label>,
			renderLogic: (row, idx) =>
				<div style={styles.actionsColumnButton}>
				<Loadable loadingStates={[COMMON_LOADING_STATES.GENERAL_LOADING]} messageMap={COMMON_LOADING_STATES_MESSAGE_MAP} currentState={loadingState.state} isNewLoadable={true}>
					<Button type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER} title={"Delete"} onClickCb={() => handleUserDelete(row)}><Icons familyName={'vec'} iconName={VEC_ICON_NAME.DELETE_ICON} /></Button>
					{row.ShowProdAppKey ? <Button type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER} onClickCb={() => handleChangeUserAccess(row)} title={'Revoke Production API Key Access'}><Icons familyName={'vec'} iconName={VEC_ICON_NAME.REVOKE_ICON} /></Button> : <Button type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER} onClickCb={() => handleChangeUserAccess(row)} title={'Share Production API Key Access'}><Icons familyName={'vec'} iconName={VEC_ICON_NAME.SHARE_ICON} /></Button>}
				</Loadable>
				</div>
		},
		{
			field: "status",
			header: <Label weight={LABEL_WEIGHT[700]}>Status</Label>,
			renderLogic: (row, idx) => <span style={styles.text}>{row.HasAccepted ? 'Accepted' : 'Invited'}</span>
		},
	]

	const handleTagsChange = (updatedTags) => {
		setEmailList(updatedTags)
	}

	const handleInviteUser = () => {
		const inputValue = commaSeperatedInputRef?.current?.value;
		if (emailList.length > 0) {
			dispatch(inviteDeveloper(emailList.join(',')))
		} else if(inputValue?.length && inputValue.length > 0 ) {
			dispatch(inviteDeveloper(inputValue))
		} else {
			dispatch(addNotifications({
				heading: "No Email Entered",
				message: ""
			}))
		}
	}

	return (
		<>
		<Breadcrumbs items={[
                        { text: 'Home', link: '/' },
                        { text: 'API', link: `/${API_SECTION_ROUTES.API}` },
                        { text: 'Developer Hub' },
                    ]} 
                />
			<div style={styles.mainContainer}>
				<div style={styles.titleRow}>
					<Heading type={HEADING.H1}>Developer Hub</Heading>
					<Button onClickCb={() => navigate(`/api/`)}>View API Keys</Button>
				</div>
				<div style={styles.actionRows}>
					<Button onClickCb={() => dispatch(setShowInvitePopup(true))}>Invite Developer</Button>
					<div style={styles.searchDiv}>
						<Label customStyles={styles.whiteSpacePre}>Search Here: </Label>
						<TextInput
							value={filterText}
							placeHolder='Search Here'
							onChangeCb={(e) => setFilterText(e.target.value)}
						/>
					</div>
				</div>
				<Loadable loadingStates={[COMMON_LOADING_STATES.GRID_LOADING]} messageMap={COMMON_LOADING_STATES_MESSAGE_MAP} currentState={loadingState.state} isNewLoadable={true}>
					<RichGrid
						data={developerData}
						columns={gridHeader}
						selectable={false}
						extractRowKey={(row) => row.UserId}
						paginationProps={{
							skip: skip,
							take: rowsPerPage,
							takeOptions: ROW_SELECTION_OPTIONS,
							onChangeTakeCb: (newTake) => {
								dispatch(setRowsPerPage(newTake));
								dispatch(setSkip(0))
							},
							total: totalDeveloper,
							onChange: (take, t) => {
								dispatch(setRowsPerPage(take));
								dispatch(setSkip(t))
							},
						}}
					/>
				</Loadable>
			</div>
			<Popup title={"Invite Developers"} onCloseCb={() => { dispatch(setShowInvitePopup(false)) }} isPopupOpen={showInvitePopup} customPopupSyles={styles.customPopupStyle} childrenStyles={styles.padding}>
				<Loadable loadingStates={[COMMON_LOADING_STATES.GENERAL_LOADING]} messageMap={COMMON_LOADING_STATES_MESSAGE_MAP} currentState={loadingState.state} isNewLoadable={true}>
					<div>Please enter comma seperated emails</div>
					<div style={styles.popupBody}>
						<Label weight={LABEL_WEIGHT[700]}>Email: </Label>
						<CommaSeparatedInput ref={commaSeperatedInputRef} value={emailList} onChangeCb={handleTagsChange} customStyles={styles.fullWidth} />
					</div>
					<div style={styles.popupActions}>
						<Button type={BUTTON_TYPE.PRIMARY} onClickCb={handleInviteUser}>Invite</Button>
						<Button type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER} onClickCb={() => {
							setEmailList([]);
							dispatch(setShowInvitePopup(false));
						}}>Cancel</Button>
					</div>
				</Loadable>
			</Popup>
		</>
	)
}